import { render, staticRenderFns } from "./SharedLayout.vue?vue&type=template&id=92ca1a3a&scoped=true"
import script from "./SharedLayout.vue?vue&type=script&lang=ts"
export * from "./SharedLayout.vue?vue&type=script&lang=ts"
import style0 from "./SharedLayout.vue?vue&type=style&index=0&id=92ca1a3a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ca1a3a",
  null
  
)

export default component.exports